import React, { ChangeEvent, useCallback, useEffect, useState } from 'react'
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  List,
  ListItem,
  ListItemText,
  TextField,
} from '@mui/material'
import { createLTIIssuer, getLTIIssuers } from 'providers/mutations'
import { GetLTIIssuers } from 'providers/resources'
import { useNotify } from 'shared/ui/Notify'
import { ICreateLTIIssuer } from 'infrastructure/api'

const AddLMSConfiguration = () => {
  const [issuer, setIssuer] = useState('')
  const [authLoginURL, setAuthLoginURL] = useState('')
  const [keySetURL, setKeySetURL] = useState('')
  const [publicKey, setPublicKey] = useState('')
  const margins = { marginBottom: 10, marginLeft: 5 }
  const [ltiIssuers, setLTIIssuers] = useState<Array<string>>(['None'])
  const notify = useNotify()
  const fetchLTIIssuers = useCallback(async () => {
    try {
      const data = await getLTIIssuers()
      if (data) {
        let list: Array<string> = []
        const issuerList = data?.[GetLTIIssuers.key]
        if (issuerList.length > 0) {
          list = issuerList
        } else {
          list.push('None')
        }
        setLTIIssuers(list)
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('Error getting LTI integration', err)
    }
  }, [])

  useEffect(() => {
    fetchLTIIssuers()
  }, [fetchLTIIssuers])

  const issuerOnChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setIssuer(e.target.value)
  }
  const authLoginURLOnChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setAuthLoginURL(e.target.value)
  }
  const keysetURLOnChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setKeySetURL(e.target.value)
  }
  const publickeyOnChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setPublicKey(e.target.value)
  }

  const displayError = (msg: string) => {
    notify(msg, { type: 'error' })
  }
  const clearFields = () => {
    setIssuer('')
    setAuthLoginURL('')
    setKeySetURL('')
    setPublicKey('')
  }

  const submit = async () => {
    if (issuer === '') {
      displayError('Issuer cannot be empty')
      return
    }
    if (authLoginURL === '') {
      displayError('Auth Login URL cannot be empty')
      return
    }
    if (keySetURL === '') {
      displayError('Key Set URL cannot be empty')
      return
    }
    const issuerCreate: ICreateLTIIssuer = {
      issuer,
      authloginurl: authLoginURL,
      keyseturl: keySetURL,
    }

    if (publicKey !== '') {
      issuerCreate.publickey = publicKey
    }

    const response = await createLTIIssuer(issuerCreate)
    if (response.errors) {
      displayError(response.errors[0].message)
    } else {
      notify('Successfuly Added LMS information')
      clearFields()
      fetchLTIIssuers()
    }
  }
  return (
    <>
      <Box display={'flex'} className={'center-items'}>
        <List>
          <span>LMS Currently Configured:</span>
          {Object.values(ltiIssuers).map((e) => (
            <ListItem>
              <ListItemText key={e}>{e}</ListItemText>
            </ListItem>
          ))}
        </List>
      </Box>
      <FormControl style={{ minWidth: 350 }}>
        <Box sx={{ border: 1, margin: 1 }}>
          <FormLabel
            sx={{
              marginLeft: '0.71em',
              marginTop: '-0.71em',
              paddingLeft: '0.44em',
              paddingRight: '0.44em',
              fontSize: '0.75em',
              width: 'auto',
            }}
          >
            Add LTI LMS Information
          </FormLabel>
          <div style={{ margin: 3 }}>
            <TextField
              value={issuer}
              label="Issuer"
              variant="outlined"
              onChange={issuerOnChange}
              size="small"
              style={margins}
              inputProps={{
                'aria-label': 'Issuer',
              }}
            />
            <TextField
              value={authLoginURL}
              label="Auth Login URL"
              variant="outlined"
              onChange={authLoginURLOnChange}
              size="small"
              style={margins}
              inputProps={{
                'aria-label': 'Auth Login URL',
              }}
            />
            <TextField
              value={keySetURL}
              label="Key Set URL"
              variant="outlined"
              onChange={keysetURLOnChange}
              size="small"
              style={margins}
              inputProps={{
                'aria-label': 'Key Set URL',
              }}
            />
            <TextField
              value={publicKey}
              label="Public Key [Optional]"
              variant="outlined"
              onChange={publickeyOnChange}
              size="small"
              style={margins}
              inputProps={{
                'aria-label': 'Public Key Optional',
              }}
            />
          </div>
        </Box>
        <Button onClick={submit} variant="outlined" color="secondary">
          Create LMS Configuration
        </Button>
      </FormControl>
    </>
  )
}

export default AddLMSConfiguration
